<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte.ts'
    import {getAllMemberships, deleteMembership, updateMembershipsPriorityIndex} from 'src/components/cabinet/#services/memberships'
    import {flip} from 'svelte/animate';
    import IconifyIcon from '@iconify/svelte'
    import editIcon from '@iconify/icons-fa-solid/edit'
    import deleteIcon from '@iconify/icons-fa-solid/trash-alt'
    import {doShow as showAlert} from 'src/components/#common/alert/store'

    getAllMemberships.reset()
    getAllMemberships.send()

    let memberships
    let hovering = false
    let selectedMembership
    let deleteMembershipModal = false
    let dragMembershipsModal = false
    let membershipsClean

    $: if (!memberships && $getAllMemberships.hasValue) {
        memberships = $getAllMemberships.value && JSON.parse(JSON.stringify($getAllMemberships.value))
        memberships.map((elem, index) => {
            elem.priorityIndex = index + 1
        })
    }

    const drop = (event, target) => {
        event.dataTransfer.dropEffect = 'move';
        const start = parseInt(event.dataTransfer.getData("text/plain"));
        const newTracklist = memberships

        if (start < target) {
            newTracklist.splice(target + 1, 0, newTracklist[start]);
            newTracklist.splice(start, 1);
        } else {
            newTracklist.splice(target, 0, newTracklist[start]);
            newTracklist.splice(start + 1, 1);
        }
        memberships = newTracklist
        hovering = null
        memberships.map((elem, index) => {
            elem.priorityIndex = index + 1
        })
        dragMembershipsModal = true
    }

    const dragstart = (event, i) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        const start = i;
        event.dataTransfer.setData('text/plain', start);
    }

    async function deleteMembershipByKey() {
        try {
            await deleteMembership.request({ data: { id: selectedMembership } })

            deleteMembershipModal = false

            showAlert.set({
                status: 'success',
                text: 'Membership successfully deleted!'
            })
        } catch (e) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            memberships = undefined
            getAllMemberships.reset()
            getAllMemberships.send()
        }
    }

    function updateMembershipsPriority() {
        membershipsClean = memberships.map((item) => {
            return {
                id: item.id,
                priorityIndex: item.priorityIndex
            }
        })
        updateMembershipsPriorityIndex.send({ data: { configParams: membershipsClean } })
        dragMembershipsModal = false
    }
</script>

<svelte:head>
    <title>Memberships</title>
</svelte:head>

<MainLayout title="Memberships">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="memberships/add" class="btn btn-success mb-3">Create membership</Link>
                <div class="table memberships-list">
                    <div class="row thead">
                        <div class="col-auto">#</div>
                        <div class="col">Membership</div>
                        <div class="col-auto" style="width:136px">Actions</div>
                    </div>
                    {#if !memberships && $getAllMemberships.loading}
                        <div class="row">
                            <div class="col text-center">Loading...</div>
                        </div>
                    {:else if !memberships && ($getAllMemberships.error || !$getAllMemberships.hasValue) }
                        An error has occurred
                    {:else if memberships && $getAllMemberships.hasValue}
                        {#each memberships as item, index (item.priorityIndex)}
                            <div class="row membership-item"
                                 draggable={true}
                                 animate:flip={{ duration: 200 }}
                                 class:is-active={hovering === index}
                                 on:dragstart={event => dragstart(event, index)}
                                 on:drop|preventDefault={event => drop(event, index)}
                                 ondragover="return false"
                                 on:dragenter={() => hovering = index}>
                                <div class="col-auto">{ item.priorityIndex }</div>
                                <div class="col" style="text-transform: capitalize;">
                                    <img src="/images/memberships/{item.membership.replace(/ /g, '_')}.svg" class="membership-icon" alt="">
                                    {item.membership}
                                </div>
                                <div class="col-auto">
                                    <Link to="memberships/edit/{item.id}" class="btn btn-primary">
                                        <IconifyIcon icon={editIcon}/>
                                    </Link>
                                    <button class="btn btn-danger" title="Delete" on:click={() => {deleteMembershipModal = true; selectedMembership = item.id }}>
                                        <IconifyIcon icon={deleteIcon}/>
                                    </button>
                                </div>
                            </div>
                        {/each}
                    {/if}
                    <Modal bind:visible={deleteMembershipModal}>
                        <svelte:fragment slot="content">
                            <div class="modal-custom__title">Delete membership</div>
                            <div class="modal-custom__text">Are you sure you want to delete this membership? <br><br>This will delete all user memberships!</div>
                            <div class="modal-custom__footer">
                                <button class="btn btn-cancel" on:click={() => { deleteMembershipModal = false }}>Cancel</button>
                                <button class="btn btn-primary btn-danger" on:click={deleteMembershipByKey}>Delete</button>
                            </div>
                        </svelte:fragment>
                    </Modal>
                    <Modal bind:visible={dragMembershipsModal}>
                        <svelte:fragment slot="content">
                            <div class="modal-custom__title">Update priorities</div>
                            <div class="modal-custom__text">Are you sure you want to update your membership priorities?</div>
                            <div class="modal-custom__footer">
                                <button class="btn btn-cancel" on:click={() => { dragMembershipsModal = false }}>Cancel</button>
                                <button class="btn btn-primary btn-success" on:click={updateMembershipsPriority}>Yes</button>
                            </div>
                        </svelte:fragment>
                    </Modal>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .membership-item {
        border: 1px solid transparent;
        border-top: 1px solid #ced4da;
        border-bottom: 1px solid #ced4da;
        margin-bottom: -1px;
        align-items: center;
        padding: 5px 0;
        cursor: grab;
    }

    .membership-item.is-active {
        background: #f1f1f3;
        cursor: grabbing;
    }

    .memberships-list {
        max-width: 400px;
    }

    .membership-icon {
        width: 38px;
        margin: 0 10px 0 0;
        display: inline-block;
        padding: 0;
    }

    @media(max-width: 767px) {
        .membership-icon {
            margin: 0 10px 0 0;
        }
    }
</style>
